import React from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import lock from "../../../assets/img/lock.jpg";

export default function Unauthorised() {
  return (
    <Container
      fluid
      className="d-flexdd flex-columndd flex-lg-rowdd justify-content-centerdd align-items-center"
      style={{ height: 400 }}
    >
      <Row className="mb-4 mt-4">
        <Col>
          <img
            src={lock}
            alt="Access Denied"
            style={{ maxWidth: "200px", width: "100%" }}
          />
        </Col>
      </Row>

      <Row>
        <Col>
          <h1 className="display-3 text-danger">403</h1>
          <h2 className="mb-2">Unauthorized Access</h2>
          <p className="text-sm mb-0 pb-0">
            Oops! You do not have the necessary permissions to access this
            resource.
          </p>
          <p className="text-sm">
           You can request for permission. Please contact the administrator for assistance.
          </p>
          <Button
            variant="link"
            href="/"
            className="p-0 text-sm text-decoration-underline"
          >
            Go to Home
          </Button>
        </Col>
      </Row>
    </Container>
  );
}
